import React, { useEffect } from "react";
import "./Modal.css";

const Modal = ({
  isOpen,
  onClose,
  title,
  children,
  submitText = "Save",
  onSubmit,
  showDelete = false,
  onDelete,
  showCopy = false,
  onCopy,
  dataTableId = null,
}) => {
  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === "Escape") {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener("keydown", handleEscape);
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }

    return () => {
      document.removeEventListener("keydown", handleEscape);
      document.body.style.overflow = "unset";
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  const handleOverlayClick = (e) => {
    if (e.target.className === "modal fade in") {
      onClose();
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('🔍 [MODAL] handleSubmit called for title:', title);
    console.log('🔍 [MODAL] Available window functions:', {
      lunchFormSubmit: !!window.lunchFormSubmit,
      propertyViewingFormSubmit: !!window.propertyViewingFormSubmit
    });
    
    // Check if there's a form-specific submit function exposed
    if (window.lunchFormSubmit && (title === "Add lunch" || title === "Edit lunch")) {
      console.log('🍽️ [MODAL] Using lunch form submit for title:', title);
      const success = window.lunchFormSubmit();
      console.log('🍽️ [MODAL] Lunch form submit result:', success);
      if (success) {
        // Form was successfully submitted, close modal
        console.log('✅ [MODAL] Lunch form submitted successfully, closing modal');
        onClose(); // Close the modal
        return;
      } else {
        console.warn('⚠️ [MODAL] Lunch form validation failed');
      }
    } else if (window.propertyViewingFormSubmit && (title === "Add property viewing" || title === "Edit property viewing")) {
      console.log('📅 [MODAL] Using property viewing form submit for title:', title);
      const success = window.propertyViewingFormSubmit();
      if (success) {
        // Form was successfully submitted, close modal
        console.log('✅ [MODAL] Property viewing form submitted successfully');
        return;
      }
    } else if (onSubmit) {
      // Fallback to regular onSubmit
      console.log('🔍 [MODAL] Using fallback onSubmit for title:', title);
      onSubmit();
    }
  };

  return (
    <div
      className="modal fade in"
      role="dialog"
      onClick={handleOverlayClick}
      data-datatable={dataTableId}
    >
      <div className="modal-dialog modal-lg">
        <div className="modal-content">
          <div className="modal-header">
            <h4 className="modal-title">{title}</h4>
            <button type="button" className="close btn-modal-close" onClick={onClose}>
              &times;
            </button>
          </div>

          <div className="modal-body" style={{ maxHeight: 'calc(80vh - 140px)', overflowY: 'auto', overflowX: 'hidden' }}>
            {children}
            
            <div className="modal-actions">
                <div className="actions-left">
                  {showDelete && (
                    <button
                      type="button"
                      className="btn btn-head btn-standard js-modal-delete-button bck-red"
                      onClick={onDelete}
                    >
                      Delete
                    </button>
                  )}
                </div>
                
                <div className="actions-right">
                  {showCopy && (
                    <button
                      type="button"
                      className="btn btn-head btn-standard js-copy-id"
                      style={{
                        background: "#1B2046",
                        color: "#fff",
                        border: "none",
                      }}
                      onClick={onCopy}
                    >
                      Copy to next week
                    </button>
                  )}

                  <button
                    type="button"
                    className="btn btn-head btn-standard modal-submit-button js-modal-create-button"
                    style={{
                      background: "#1B2046",
                      color: "#fff",
                      border: "none",
                    }}
                    onClick={handleSubmit}
                  >
                    {submitText}
                  </button>
                </div>
              </div>
          </div>

          <div className="modal-footer">
            <button type="button" className="btn btn-default btn-modal-close" onClick={onClose}>
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Modal;
